import { gql } from '@apollo/client';

export const GET_ACTIVE_USERS = gql`
  query getActiveUsers($startDate: String, $endDate: String, $schoolsIds: [String], $period: String) {
    getActiveUsers(startDate: $startDate, endDate: $endDate, period: $period, schoolsIds: $schoolsIds) {
      totalUsers
      totalActiveUsers
      data {
        countUniqueUsers
        schoolId
        schoolName
        date
      }
    }
  }
`;

export const MOST_USED_FEATURES = gql`
  # , $period: String
  query MostUsedFeatures($startDate: String, $endDate: String, $schoolsIds: [String]) {
    getFeatureUsage(startDate: $startDate, endDate: $endDate, schoolsIds: $schoolsIds) {
      schoolId
      schoolName
      features {
        feature
        pageViewsCount
      }
    }
  }
`;

export const FEATURE_FREQUENCY = gql`
  query FeatureFrequency($startDate: String, $endDate: String, $schoolsIds: [String], $period: String) {
    getFeatureFrequency(startDate: $startDate, endDate: $endDate, schoolsIds: $schoolsIds, period: $period) {
      schoolId
      schoolName
      date
      features {
        feature
        averageUseInSeconds
      }
    }
  }
`;

export const SCHOOL_MOOD = gql`
  # , $period: String
  query SchoolMood($startDate: String, $endDate: String, $schoolsIds: [String]) {
    getSchoolMood(startDate: $startDate, endDate: $endDate, schoolsIds: $schoolsIds) {
      schoolId
      schoolName
      emotions {
        emotion
        count
        type
        overallMoodIcon
      }
      data {
        schoolId
        schoolName
        emotion
        type
        idUser
      }
    }
  }
`;

export const SCHOOL_ENGAGEMENT = gql`
  # , $period: String
  query SchoolEngagement($schoolsIds: [String]) {
    getSchoolEngagement(schoolsIds: $schoolsIds) {
      differenceInSeconds
      differenceInHoursMinutesAndSeconds
      increased
      percentage
    }
  }
`;

export const GET_SURVEY_CHANGE = gql`
  query GetSurveyChange($schoolsIds: [String]) {
    calculateSurveyResponseChange(schoolsIds: $schoolsIds) {
      totalCurrentWeek
      totalPreviousWeek
      increase
    }
  }
`;
